import React from "react";

interface Props {
  values: any;
  onBack: () => void;
  onSubmit: () => void;
  loading?: boolean;
}

const Summary: React.FC<Props> = ({ values, onBack, onSubmit, loading }) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Confirm details</h3>

      <div className="border rounded p-4">
        <h4 className="font-semibold">Business</h4>
        <p><span className="font-medium">Name:</span> {values.businessName}</p>
        {values.website && <p><span className="font-medium">Website:</span> {values.website}</p>}
        {values.description && <p><span className="font-medium">Description:</span> {values.description}</p>}
        <p className="mt-2">
          {values.logo && <img src={values.logo} alt="logo" className="w-40 h-24 object-cover rounded" />}
        </p>
      </div>

      <div className="border rounded p-4">
        <h4 className="font-semibold">Admin</h4>
        <p><span className="font-medium">Name:</span> {values.firstname} {values.lastname}</p>
        <p><span className="font-medium">Username:</span> {values.username}</p>
        <p><span className="font-medium">Email:</span> {values.email}</p>
        <p><span className="font-medium">Phone:</span> {values.phone_number}</p>
      </div>

      <div className="flex justify-between">
        <button
          onClick={onBack}
          className="px-4 py-2 rounded-md border border-gray-300 text-sm"
        >
          Back
        </button>

        <button
          onClick={onSubmit}
          className="form-btn-mini"
          disabled={loading}
        >
          {loading ?
            <div className="flex items-center gap-2">
              <span className="loader"></span>
              <span>Registering...</span>
            </div>
            :
            "Confirm & Create"}
        </button>
      </div>
    </div>
  );
};

export default Summary;
